import { administrationRequests } from "api/administrationApi";
import React from "react";
import { ReferenceArrayField, SelectField, SingleFieldList } from "react-admin";
import { CitizenTypeOptions } from "utils/choices";

const CitizenshipFiled = ({ isArray }) => {
  return isArray ? (
    <ReferenceArrayField
      source="citizenship"
      reference={administrationRequests.getCitizenshipSelect()}
      onClick={e => e.preventDefault()}
    >
      <SingleFieldList
        linkType={false}
        source="name"
      />
    </ReferenceArrayField>
  ) : (
    <SelectField
      source="citizenship"
      choices={CitizenTypeOptions}
    />
  );
};

export default CitizenshipFiled;
